<template>
    <div class="form-group">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'FormGroup'
};
</script>
